import { Menu } from '@pocketlaw/tetris';
import { useSearchableMenu } from './SearchableMenuContext';
export function SearchableMenuPopover(props) {
    const { renderTarget, children } = props;
    const { open, setOpen, items } = useSearchableMenu();
    return (<Menu target={renderTarget({ open, setOpen, items })} open={open} onClose={() => setOpen(false)} options={{ placement: 'bottom-start' }}>
      {children}
    </Menu>);
}
